import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Container from "../components/Container";
import Meta from "../components/Meta";

const ShippingPolicy = () => {
  return (
    <>
      <Meta title={"Shipping Policy - Shoplintic Fashion & Beauty"} />
      <BreadCrumb title="Shipping Policy - Fashion & Beauty" />
    <div className="bg-gray-50 min-h-screen py-12 ">
      <div className="p-4 max-w-5xl mx-auto bg-white p-10 rounded-2xl shadow-lg">
        <h2 className="text-4xl font-bold text-blue-700 mb-8 text-center">Shipping Policy</h2>

        <p className="text-gray-700 mb-6">
          Thank you for visiting and shopping at <strong>Shoplintic</strong>. This Shipping Policy outlines the terms and conditions that apply to the shipping of fashion and beauty products purchased through our website at <a href="https://shoplintic.in" className="text-blue-600 underline">shoplintic.in</a>. We are committed to delivering your clothing and cosmetics items promptly and securely.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">1. Processing Time</h4>
        <p className="text-gray-700 mb-6">
          All orders are processed within <strong>1–3 business days</strong>. Orders placed on weekends or public holidays will be processed on the next working day. During high-demand periods (such as sales, festivals, or new product launches), processing times may be slightly extended. You will be notified if there are any unexpected delays.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">2. Shipping Methods & Delivery Time</h4>
        <p className="text-gray-700 mb-6">
          We offer reliable shipping through trusted courier services to ensure your fashion and beauty products reach you safely and on time.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li><strong>Standard Shipping (India):</strong> 3–7 business days</li>
          <li><strong>Express Shipping (India):</strong> 1–3 business days</li>
          <li><strong>International Shipping:</strong> 7–21 business days (depending on location)</li>
        </ul>

        <p className="text-gray-700 mb-6">
          Please note: Delivery times are estimates and may vary due to external factors such as courier availability, remote locations, weather conditions, and public holidays. For time-sensitive items like cosmetics with expiration dates, we recommend express shipping.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">3. Shipping Charges</h4>
        <p className="text-gray-700 mb-6">
          Shipping charges are calculated during checkout based on the weight, size, and destination of your order. We offer free shipping on orders above ₹999 for clothing items and ₹499 for cosmetics. Keep an eye out for our seasonal shipping promotions!
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">4. Tracking Information</h4>
        <p className="text-gray-700 mb-6">
          Once your order is shipped, you will receive a confirmation email or SMS containing your tracking number and a link to track your shipment. Tracking may take up to 24 hours to activate after dispatch. For valuable or fragile items, we recommend using registered shipping with tracking.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">5. International Shipping</h4>
        <p className="text-gray-700 mb-6">
          We currently support international shipping to select countries. International customers are responsible for any customs duties, taxes, or import fees that may apply. These charges are not included in the purchase price or shipping fees and are determined by your local customs office. Please note that some cosmetics may be subject to additional import regulations.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">6. Delays and Undeliverable Packages</h4>
        <p className="text-gray-700 mb-6">
          While we strive to deliver all orders promptly, unforeseen circumstances like courier issues, weather events, or customs delays may cause delays. If a shipment is returned to us due to an incorrect address or unsuccessful delivery attempts, we will contact you to arrange redelivery. Additional shipping charges may apply for redelivery.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">7. Shipping Partners</h4>
        <p className="text-gray-700 mb-6">
          We work with trusted shipping partners such as Delhivery, Blue Dart, India Post, and FedEx to deliver your fashion and beauty products efficiently and securely. For international orders, we may use DHL, Aramex, or other globally recognized couriers. All partners are selected for their reliability and care in handling delicate items.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">8. Address Accuracy</h4>
        <p className="text-gray-700 mb-6">
          Please ensure your shipping address is accurate and complete before placing your order. For clothing exchanges or returns, accurate addresses are crucial. We are not responsible for delays or failed deliveries due to incorrect or incomplete addresses provided by customers.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">9. Packaging & Product Care</h4>
        <p className="text-gray-700 mb-6">
          <strong>Clothing Items:</strong> All garments are carefully folded, wrapped in protective plastic, and boxed to prevent wrinkles and damage. We use eco-friendly packaging materials wherever possible.<br /><br />
          <strong>Cosmetics:</strong> Beauty products are securely packaged in protective boxes with bubble wrap to prevent breakage. Temperature-sensitive items are packed with cooling materials when necessary. All products include care instructions and expiration dates.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">10. Product Freshness Guarantee</h4>
        <p className="text-gray-700 mb-6">
          For cosmetics and beauty products, we guarantee freshness and quality. All products have clearly marked manufacturing and expiration dates. If you receive a product that appears compromised or expired, please contact us immediately for a replacement or refund.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">11. Contact Us</h4>
        <p className="text-gray-700 mb-6">
          If you have any questions or concerns about your shipment, please don’t hesitate to reach out to our support team. We're happy to help with tracking, delivery issues, or any shipping-related questions.
        </p>
        <p className="text-gray-700 mb-6">
          📧 Email: <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a><br />
          🌐 Website: <a href="https://shoplintic.in" className="text-blue-600 underline">shoplintic.in</a>
        </p>

        <p className="text-sm text-gray-500 mt-10">Last Updated: December 21, 2025</p>
      </div>
    </div>

    </>
  );
};

export default ShippingPolicy;
